import { render, staticRenderFns } from "./LoginNeededPopup.vue?vue&type=template&id=56976884&"
import script from "./LoginNeededPopup.vue?vue&type=script&lang=js&"
export * from "./LoginNeededPopup.vue?vue&type=script&lang=js&"
import style0 from "./LoginNeededPopup.vue?vue&type=style&index=0&id=56976884&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports